import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'readableDateTime',
    standalone: false
})
export class ReadableDateTimePipe implements PipeTransform {

  transform(
      value: string | Date | null | undefined,
      part: 'date' | 'time' | 'both' = 'both'
  ): string | null {

    if (!value) { // check if the value is null before performing any transformations
      return null;
    }

    const datePipe = new DatePipe('nl-NL');

    const weekday = datePipe.transform(value, 'EEEE', 'CEST', 'nl-NL');
    const capitalizedWeekday = weekday        ? weekday.charAt(0).toUpperCase() + weekday.slice(1)        : null;

    const fullDate = datePipe.transform(value, 'd MMMM y', 'CEST', 'nl-NL');
    const time = datePipe.transform(value, 'HH:mm', 'CEST', 'nl-NL');

    if (part === 'time') {
      return time || null;
    }

    // part === 'date' or 'both'
    const dateOnly = [capitalizedWeekday, fullDate].filter(Boolean).join(' ');
    if (part === 'date') {
      return dateOnly || null;
    }

    // both
    if (dateOnly && time) {
      return `${dateOnly} om ${time}`;
    }

    // fallback if something missing
    return dateOnly || time || null;
  }

}
